import { Icon, Tooltip, Typography } from '@mui/material';
import { AttendanceCode } from '@schooly/api';
import { CalendarQuestionIcon, DisabledNotificationIcon, NotificationIcon } from '@schooly/style';
import { FC } from 'react';
import { useIntl } from 'react-intl';

type AttendanceCodeIconProps = {
  code: AttendanceCode;
  notificationsDisabled: boolean;
};

export const AttendanceCodeIcon: FC<AttendanceCodeIconProps> = ({
  code,
  notificationsDisabled,
}) => {
  const { formatMessage } = useIntl();

  if (!code.has_justification && !code.has_push_notifications) return null;

  const getIcon = () => {
    if (code.has_justification) {
      return <CalendarQuestionIcon />;
    }
    return notificationsDisabled ? <DisabledNotificationIcon /> : <NotificationIcon />;
  };

  const getTooltipTitle = () => {
    if (code.has_justification) {
      return (
        <>
          <Typography mb={2}>
            {formatMessage({ id: 'attendance-justification-ParentSubmissionHint' })}
          </Typography>
          <Typography>
            {formatMessage({ id: 'attendance-justification-ParentSubmissionHint-2' })}
          </Typography>
        </>
      );
    }
    return formatMessage({
      id: notificationsDisabled
        ? 'attendance-ParentNotification-Disabled'
        : 'attendance-ParentNotification',
    });
  };

  return (
    <Tooltip
      componentsProps={{ tooltip: { sx: { padding: 1.25, width: 200 } } }}
      title={getTooltipTitle()}
    >
      <Icon
        fontSize="small"
        className="notificationIcon"
        sx={{ color: notificationsDisabled ? 'common.grey' : undefined }}
      >
        {getIcon()}
      </Icon>
    </Tooltip>
  );
};
